import { features as featureNames, FeatureType } from '@src/defs/features.js';
import {
  ConsentSaveType, ConsentType, FeatureItemSaveType, FeatureItemType,
} from '@src/types/common.js';

function* getFeaturesIterator(consent: ConsentType) {
  for (const featureName of featureNames) {
    if (consent[featureName]) {
      yield* consent[featureName] as FeatureItemType[];
    }
  }
}

const consentHasAtLeastOneNotGrantedFeature = (consent: ConsentType) => {
  let ret = false;
  for (const { granted } of getFeaturesIterator(consent)) {
    if (!granted) {
      ret = true;
      break;
    }
  }
  return ret;
};

export function haveUncheckedFeatures(consents: ConsentType[]) {
  return !!consents.find(consentHasAtLeastOneNotGrantedFeature);
}

export const mapConsentFeaturesTo = <T>(
  consent: ConsentType | ConsentSaveType,
  callback: (feature: FeatureItemType | FeatureItemSaveType, featureName: FeatureType) => T,
) => {
  const ret: Partial<Record<FeatureType, T[]>> = {};

  featureNames.forEach((featureName) => {
    if (!consent[featureName]) {
      return;
    }

    ret[featureName] = consent[featureName].map((feature) => callback(feature, featureName));
  });

  return ret;
};

export const getAllFeatures = (consent: ConsentType) => Array.from(getFeaturesIterator(consent));
